import { useContext, useRef, useState } from "react";

import { trimEnd } from "lodash";
import { useRouter } from "next/router";
import Cta from "./Cta";
import Header from "./Header";
import IndexLayout from "./IndexLayout3";
import UserContext from "./UserContext";
import Stars from "./Stars";
import Link from "next/link";
import { Spinner } from "./Spinner";

export default function MyLayout(props) {
    const router = useRouter();
    const { user, supabase } = useContext(UserContext);
    const [createLoading, setCreateLoading] = useState(false);

    return (
        <IndexLayout headerContent={(<div className="flex flex-col sm:flex-row mx-4 my-32 mb-8 sm:mb-16 sm:mx-8 lg:mx-32 xl:mx-48 2xl:mx-64 mt-8 sm:mt-16 text-2xl lg:text-2xl xl:text-5xl text-white font-semibold text-left">
            <div className="flex flex-1 flex-row order-2 sm:order-1 z-30">
                <div className="-mt-16 sm:mt-0">
                    <div className="mt-6 sm:mt-0 font-serif sm:mx-8" style={{ letterSpacing: "0.03em", lineHeight: "1.15em" }}>
                        {props.title}
                    </div>
                    <div className="sm:mx-8 mt-2 sm:mt-6 text-lg font-light">
                        {props.subtitle}
                    </div>
                    <div className="sm:mx-8 mt-6">
                        <div className="inline-block">
                            <Link href={props.buttonLink || "/create"}>
                                <button
                                    onClick={() => setCreateLoading(true)}
                                    type="button"
                                    className="text-xl items-center font-bold bg-secondary-dark disabled:bg-gray-500 inline-flex justify-center rounded-md px-8 py-3 text-white  focus:outline-none sm:col-start-2 sm:text-sm hover:bg-secondary-darkest"
                                >
                                    {props.buttonTitle ? props.buttonTitle : (<>
                                        {createLoading ? (
                                            <div className="-ml-1 -mt-1 -mb-1 mr-1 w-6 h-6">
                                                <Spinner />
                                            </div>
                                        ) : (
                                            <span className="text-lg mr-2 sparkle w-4 fill-white text-white">
                                                <img alt="Create now" width="16" height="15" src="/sparkle-white.svg" />
                                            </span>)}
                                        <div>Create now</div></>)}
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative flex-1 order-1 sm:order-2 flex justify-center sm:ml-2">
                <div className="sm:-m-80 sm:-mt-6 sm:-ml-80 -mr-4 h-96 sm:h-full content-center justify-center">
                    <div className="h-72 sm:h-full overflow-hidden sm:overflow-visible text-center" style={{ 'text-align': '-webkit-center' }}><img className="rounded-xl" width="360" src={props.image} /></div>
                </div>
            </div>
        </div>)} {...props} />
    );
}
